// extracted by mini-css-extract-plugin
module.exports = {"addProgram":"MainForm_addProgram__1KOpr","inputRow":"MainForm_inputRow__2QrxL"};